import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PlainIconButton } from '@interxfi/design-system/components/button';
import InfoIcon from '@interxfi/design-system/icons/react/icon-info';
import { CorrespondentAccountDescriptionDrawer } from '../../../../../../../../features/registration/account/correspondent-account-description-drawer';
import { CorrespondentAccountsTable } from '../../../../../../../../features/registration/account/correspondent-accounts-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/correspondent')({
  // staticData: {
  //   tab: {
  //     group: TabbedNavigationGroup.ClearingOperationsPlatformAccount,
  //     label: 'Correspondent',
  //     order: 1,
  //   },
  // } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsPlatformAccount>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'correspondent-account-list',
        label: 'Correspondent Accounts',
        to: '/clearing/operations/account/correspondent',
        suffix: (
          <CorrespondentAccountDescriptionDrawer
            trigger={
              <PlainIconButton aria-label="View more information about correspondent accounts">
                <InfoIcon aria-hidden width={16} />
              </PlainIconButton>
            }
          />
        ),
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Correspondent Accounts'),
  component: CorrespondentAccountList,
});

function CorrespondentAccountList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <CorrespondentAccountsTable />
      </PageLayout.Section>
    </PageLayout>
  );
}
